import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Button, Box, Fade, Paper } from '@material-ui/core'
import { FormLoader } from '../../../Loader/FormLoader'
import { formStyles } from '../FormStyles'
import { useStyles } from '../Styles'
import { useFormik } from 'formik'
import { CreateInvoiceStep4FormValidation } from '../../../../utils/validationSchema'
import Order from './Order'
import Payment from './Payment'
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined'
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined'
import TrendingUpIcon from '@material-ui/icons/TrendingUp'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import { LanguageConsumer } from '../../../../context/LanguageContext'
import SaveInvoiceBtn from '../../SaveInvoiceBtn'

const InvoiceCreateStep4 = ({ invoiceData, onSubmit, handleBackStep, handleSaveInvoiceEntity, savedTemplateData }) => {
  const classes = useStyles()
  const formClasses = formStyles()
  const invoiceStep4Form = useFormik({
    initialValues: (!!Object.keys(invoiceData?.step4 || {}).length) ? invoiceData.step4 : {
      purchaseOrderReference: '',
      purchaseOrderDescription: '',
      salesOrderReference: '',
      salesOrderDescription: '',
      proformaInvoiceNumber: '',
      bankName: '',
      bankAddress: '',
      bankAccountNo: '',
      bankAccountIBAN: '',
      swiftCode: '',
      paymentTerms: ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    // isInitialValid: false,
    validationSchema: CreateInvoiceStep4FormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions, 'step4')
    })
  })

  return (
    <Fade in={true}>
      <Paper elevation={4} className={classes.invoiceStepWrapper + ' step2'}>
        <form onSubmit={invoiceStep4Form.handleSubmit} noValidate autoComplete="off"
              className={formClasses.formWrapper}>
          <Order formActions={invoiceStep4Form} formClasses={formClasses}
                 data={{
                   icon: <TrendingUpIcon color={'primary'}/>,
                   title: <><FormattedMessage id='InvoiceSteps.step4.Order.title'/> <span
                     className={classes.Optional}>(<FormattedMessage id='Optional'/>)</span></>
                 }}/>
          <Payment formActions={invoiceStep4Form} formClasses={formClasses}
                   data={{
                     icon: <AccountBalanceIcon color={'primary'}/>,
                     title: <><FormattedMessage id='InvoiceSteps.step4.Payment.title'/> <span
                       className={classes.Optional}>(<FormattedMessage id='Optional'/>)</span></>
                   }}/>

          <LanguageConsumer>
            {({ locale }) => (
              <Box px={3} className={formClasses.FormSubmitRow + ' between'}>
                <Button variant={'outlined'} size={'large'} color={'secondary'}
                        className={formClasses.InvoiceStepGoBack} onClick={handleBackStep}>
                  {locale === 'ar' ? <ArrowForwardIosOutlinedIcon/> : <ArrowBackIosOutlinedIcon/>}
                  <FormattedMessage id='requestStep.button.previous'/>
                </Button>
                <div>
                  <SaveInvoiceBtn disabled={!!invoiceStep4Form.isSubmitting || !invoiceStep4Form.isValid}
                                  savedTemplateData={savedTemplateData}
                                  handleSaveInvoiceEntity={(e, entityType, tempData, formikActions, closeDialog) => handleSaveInvoiceEntity(e, entityType,
                                    invoiceStep4Form.values, 'step4', tempData, formikActions, closeDialog)}/>
                  <Button type={'submit'} variant={'contained'} size={'large'} color={'secondary'}
                          onClick={invoiceStep4Form.handleSubmit}
                          disabled={invoiceStep4Form.isSubmitting || !invoiceStep4Form.isValid}
                  >
                    <FormattedMessage id='invoiceSteps.button.submit'/>
                    {locale === 'ar' ? <ArrowBackIosOutlinedIcon/> : <ArrowForwardIosOutlinedIcon/>}
                  </Button>
                </div>
              </Box>
            )}
          </LanguageConsumer>
          {!!invoiceStep4Form.isSubmitting && <FormLoader loading={true}/>}
        </form>
      </Paper>
    </Fade>
  )
}

export default InvoiceCreateStep4
